import { useAppSelector } from '../../hooks';
import {
  selectActiveTenantSession,
  selectHasMultipleSessions,
} from '../../containers/Organizations/OrganizationsSlice';
import { isMultiOrgFeatureEnabled } from '../features';

/**
 * Returns the active tenant's name when multi-org chrome should be shown,
 * or `undefined` when the subtitle should be hidden (single-org or feature off).
 *
 * Use this in screen headers to show which organisation is currently active
 * without rendering the full MultiOrgActiveBanner card.
 */
export function useTenantNameSubtitle(): string | undefined {
  const hasMultipleSessions = useAppSelector(selectHasMultipleSessions);
  const activeSession = useAppSelector(selectActiveTenantSession);

  const shouldShow = isMultiOrgFeatureEnabled() && hasMultipleSessions && activeSession != null;

  return shouldShow ? activeSession.tenantName : undefined;
}
